export default __webpack_public_path__ + "static/media/Head_6_Ear_2_C3.4a966878.svg";